// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  margin-right: 5px;
  margin-left: 5px;
}

.card-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  position: absolute;
  top: 8px;
  right: 8px;
}

.user-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
  justify-content: center;
}

.user-controls mat-form-field {
  min-width: 200px;
  flex: 1 1 200px;
  max-width: 320px;
}

.tree-reference {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/user/user.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb","sourcesContent":["button {\n  margin-right: 5px;\n  margin-left: 5px;\n}\n\n.card-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  position: absolute;\n  top: 8px;\n  right: 8px;\n}\n\n.user-controls {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  justify-content: center;\n}\n\n.user-controls mat-form-field {\n  min-width: 200px;\n  flex: 1 1 200px;\n  max-width: 320px;\n}\n\n.tree-reference {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
